import React from 'react';
import { ChevronLeft } from 'lucide-react';
import { useSidebar } from '@/components/ui/sidebar';

/**
 * CollapseButton - Bouton collapse moderne avec design turquoise
 * 
 * Ce composant implémente le bouton collapse avec le design exact
 * spécifié : position fixe, couleur turquoise, animations fluides.
 * 
 * Fonctionnalités:
 * - Position fixe qui s'adapte à l'état de la sidebar
 * - Design turquoise moderne avec coins arrondis
 * - Icône chevron qui tourne selon l'état
 * - Animations hover et active
 * - Responsive (masqué sur mobile)
 */
export const CollapseButton: React.FC = () => {
  const { toggleSidebar } = useSidebar();

  return (
    <button
      className="collapse-button"
      onClick={toggleSidebar}
      aria-label="Toggle sidebar"
      type="button"
    >
      <ChevronLeft />
    </button>
  );
};